// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"36a9e6a3","464":"5d8d77fa"}[chunkId] + ".chunk.js";
};